var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Location } from "@angular/common";
import { OnInit } from "@angular/core";
import { SharedRoutes } from "shared/lib/common/enums";
import { PosConnectionService, RoutingService, ToastService, TranslateService } from "shared/lib/common/services";
import { DeviceMountingService, ProgramService } from "shared/lib/v2/services";
import { FormBuilder, Validators } from "@angular/forms";
import { ConfigService } from "shared/lib/common/services";
var MountingSettingsPage = /** @class */ (function () {
    function MountingSettingsPage(fb, program, routing, toast, location, config, posConnectionService, deviceMountingService, translate) {
        this.fb = fb;
        this.program = program;
        this.routing = routing;
        this.toast = toast;
        this.location = location;
        this.config = config;
        this.posConnectionService = posConnectionService;
        this.deviceMountingService = deviceMountingService;
        this.translate = translate;
    }
    MountingSettingsPage.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            appInteractionId: ["", [Validators.required]],
            deviceInformation: [""],
        });
    };
    MountingSettingsPage.prototype.ionViewDidEnter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_1, e;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.program.getInteractionPointsOfProgram(this.config.getOrganization(), undefined, true).toPromise()];
                    case 1:
                        resp = _a.sent();
                        this.interactionPoints = resp.filter(function (i) { return i.type !== "CASHIER"; });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        e = error_1.error && error_1.error.message ? error_1.error.message : error_1.message || error_1;
                        this.toast.show(this.translate._(e), "error");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MountingSettingsPage.prototype.back = function () {
        this.location.back();
    };
    MountingSettingsPage.prototype.mountDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, _b, error_2, e;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.deviceMountingService.mount(this.form.get("appInteractionId").value.id || this.form.get("appInteractionId").value, this.form.get("deviceInformation").value)];
                    case 1:
                        res = _c.sent();
                        if (!(res.ok === true)) return [3 /*break*/, 7];
                        _b = (_a = this.config).setMountingConfig;
                        return [4 /*yield*/, this.deviceMountingService.parseMountingConfigV1ToV2(res.response)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        this.posConnectionService.connectToSocket(res.response.deviceKey);
                        this.translate.setLanguage(res.response.profile.language === "de" ? "de" : "en");
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ video: true })];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _c.sent();
                        this.toast.show("Camera access denied", "error");
                        return [3 /*break*/, 6];
                    case 6:
                        this.routing.goForward([SharedRoutes.screenSaver]);
                        return [3 /*break*/, 8];
                    case 7:
                        e = res.error.error && res.error.error.message ? res.error.error.message : res.error.message || res.error;
                        this.toast.show(this.translate._(e), "error");
                        _c.label = 8;
                    case 8:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MountingSettingsPage.prototype.checkErrors = function (formControlName) {
        var control = this.form.get(formControlName);
        return control.invalid && control.touched;
    };
    MountingSettingsPage.prototype.onChangeSearch = function (value) {
        this.form.get("appInteractionId").patchValue(value);
    };
    return MountingSettingsPage;
}());
export { MountingSettingsPage };
